import { apiRequest } from "../../services/apiService";
import {
  ADD_TEAM_FAIL,
  ADD_TEAM_REQUEST,
  ADD_TEAM_SUCCESS,
  DELETE_TEAM_FAIL,
  DELETE_TEAM_REQUEST,
  DELETE_TEAM_SUCCESS,
  EDIT_TEAM_FAIL,
  EDIT_TEAM_REQUEST,
  EDIT_TEAM_SUCCESS,
  GET_TEAM_FAIL,
  GET_TEAM_LIST_DATA_FAIL,
  GET_TEAM_LIST_DATA_REQUEST,
  GET_TEAM_LIST_DATA_SUCCESS,
  _DETAIL,
  GET_TEAM_SUCCESS,
  LEAVE_TEAM_FAIL,
  LEAVE_TEAM_REQUEST,
  LEAVE_TEAM_SUCCESS,
  GET_TEAM_DETAIL_REQUEST,
  GET_TEAM_DETAIL_SUCCESS,
  GET_TEAM_DETAIL_FAIL,
  GET_TEAM_REQUEST,
  ADD_TEAM_MEMBER_REQUEST,
  ADD_TEAM_MEMBER_FAIL,
  ADD_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAIL,
} from "../constant";

export const getTeamList = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_TEAM_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/teams/getTeamList`,
      data: data,
    });
    if (response) {
      console.log("response", response.data.data);
      dispatch({ type: GET_TEAM_SUCCESS, payload: response?.data });

      dispatch({ type: GET_TEAM_LIST_DATA_REQUEST, payload: response?.data });
      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_TEAM_LIST_DATA_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_TEAM_FAIL });
    }
  };
};

export const leaveTeam = (data) => {
  return async (dispatch) => {
    console.log(data, "data");
    dispatch({ type: LEAVE_TEAM_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/teams/leaveTeam`,
      data: data,
    });
    if (response) {
      dispatch({ type: LEAVE_TEAM_SUCCESS });
      console.log(response,"team leave");
    } else if (error) {
      dispatch({ type: LEAVE_TEAM_FAIL });
      console.log(response,"team error");
    }
  };
};
export const addTeam = (data) => {
  return async (dispatch) => {
    dispatch({ type: ADD_TEAM_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/teams/addTeam`,
      data: data,
    });
    if (response) {
      dispatch({ type: ADD_TEAM_SUCCESS });
    } else if (error) {
      dispatch({ type: ADD_TEAM_FAIL });
    }
  };
};
export const editTeam = (data) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_TEAM_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `/teams/updateTeam`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_TEAM_SUCCESS });
    } else if (error) {
      dispatch({ type: EDIT_TEAM_FAIL });
    }
  };
};
export const deleteTeam = (data) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_TEAM_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/teams/deleteTeam`,
      data: data,
    });
    if (response) {
      dispatch({ type: DELETE_TEAM_SUCCESS });
      const payload = {
        startingLimit: 0,
        resultsPerPage: 8,
        search: "",
        sort_by: "team_name",
        sort_order: "asc",
      };
      getTeamList(payload);
    } else if (error) {
      dispatch({ type: DELETE_TEAM_FAIL });
    }
  };
};
export const getTeamDetail = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_TEAM_DETAIL_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/teams/getTeamDetail`,
      data: data,
    });
    console.log("response data", response.data);

    if (response) {
      dispatch({ type: GET_TEAM_DETAIL_SUCCESS, payload: response.data });
    } else if (error) {
      dispatch({ type: GET_TEAM_DETAIL_FAIL });
    }
  };
};

export const addTeamMember = (data) => {
  // console.log(data);
  // return
  return async (dispatch) => {
    dispatch({ type: ADD_TEAM_MEMBER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/teams/addTeamMember`,
      data: data,
    });
    if (response) {
      dispatch({ type: ADD_TEAM_MEMBER_SUCCESS, payload: response.data });
    } else if (error) {
      dispatch({ type: ADD_TEAM_MEMBER_FAIL });
    }
  };
};

export const deleteTeamMember = (data) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_TEAM_MEMBER_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/teams/deleteTeamMember`,
      data: data,
    });
    if (response) {
      dispatch({ type: DELETE_TEAM_MEMBER_SUCCESS});
    } else if (error) {
      dispatch({ type: DELETE_TEAM_MEMBER_FAIL });
    }
  };
};
